/* eslint-disable standard/no-callback-literal */
import * as types from './types'
import store from '@/store'
import globals from '@/plugins/globals.js'
import SendBird from 'sendbird'

export default {
  strict: false,
  namespaced: true,
  sendbird: null,
  channel: null,
  channelSet: null,
  channelListQuery: null,
  memberCount: 0,
  memberList: [],
  initSendBird: function (callback) {
    this.sendbird = new SendBird({
      appId: globals.sendbirdToken()
    })
  },
  disconnect: function (callback) {
    if (this.sendbird !== undefined && this.sendbird !== null) {
      this.sendbird.disconnect(callback)
    }
  },
  connectChat: function (register, callback) {
    var self = this
    this.initSendBird()
    this.sendbird.connect(register.userId.trim(), (user, error) => {
      if (error) {
        let auditRec = {
          source: 'Portal3',
          userIds: user,
          channel: self.channel.url,
          details: error
        }
        store.dispatch('sendbird/audit', auditRec)
        console.error(error)
        return
      }
      this.sendbird.updateCurrentUserInfo(register.nickname.trim(), '', (response, error) => {
        if (error) {
          console.error(error)
        } else {
          callback(response)
        }
      })
      let channelHandler = new this.sendbird.ChannelHandler()
      channelHandler.onMessageReceived = async function (channel, message) {
        console.log('Message Received', message)
        if (message.messageType === 'user') {
          console.log('user message:', message)
          // Handle user text based message non-file
          let languages = []
          let language = store.getters['auth/language']
          if (language !== undefined && language !== null) {
            if (language === 'gr') {
              language = 'el'
            }
            languages.push(language)
          }
          languages.push('en')

          const msg = await channel.translateUserMessage(message, languages)
          if (globals.isClever()) {
            // If Clever, don't translate the message
            message.message = msg.message
          } else {
            message.message = msg.translations[language] // user's language.
          }
          let auditRec = {
            source: 'Portal3',
            userIds: message._sender.userId,
            channel: message.channelUrl,
            details: `(onMessageReceived) ${message.message}`
          }
          store.dispatch('sendbird/audit', auditRec)
          store.dispatch('sendbird/addMessageToList', message)
        } else if (message.messageType === 'file') {
          // Handle file messages
          console.log('File message:', message)
          let auditRec = {
            source: 'Portal3',
            userIds: message._sender.userId,
            channel: message.channelUrl,
            details: `(onMessageReceived) File: ${message.name || 'Unknown file'}`
          }
          store.dispatch('sendbird/audit', auditRec)
          store.dispatch('sendbird/addAttachmentToMessageList', message)
        }

        var chatDialog = document.getElementById('rightSlideOut')
        if (chatDialog.style.display === 'none') {
          document.getElementById('chatNotifier').play()
        }
        setTimeout(function () {
          globals.scrollToBottom('chatMessages')
        }, 250)
      }
      channelHandler.onMessageUpdated = function (channel, message) {
        if (message.isFileMessage && message.isFileMessage()) {
          console.log('File Message Updated', message)
        } else {
          console.log('Message Updated', message)
        }
      }
      channelHandler.onMessageDeleted = function (channel, messageId) {
        console.log('Message Deleted', messageId)
      }
      channelHandler.onChannelChanged = function (channel) {
        console.log('Channel Changed', channel)
        self.getTotalUnreadCount(counts => {
        })
        store.dispatch('serviceRequests/updateRequestUnread', { id: channel.name, count: channel.unreadMessageCount })
      }
      channelHandler.onChannelDeleted = function (channelName) {
        const appId = globals.appId()
        if (appId === 4) return

        const name = String(channelName || '')
        if (!name.startsWith('group_channel_')) return

        const request = name.replace('group_channel_', '').trim()
        const workOrderId = Number.parseInt(request, 10)

        if (Number.isInteger(workOrderId) && workOrderId > 0) {
          localStorage.setItem('survey_pending_workOrderId', String(workOrderId))
          localStorage.setItem('survey_pending_setAt', String(Date.now()))
        }

        alert(`Service Request #${request} has been Completed.`)
        window.location.assign('/')
      }

      channelHandler.onTypingStatusUpdated = function (channel) {
        store.dispatch('sendbird/setTyping', channel)
      }
      channelHandler.onReadReceiptUpdated = function (channel) {
        console.log('Message Read', channel)
      }
      channelHandler.onUserLeft = function (channel, user) {
        console.log('User Left', user)
      }
      channelHandler.onUserJoined = function (channel, user) {
        console.log('User Joined', user)
      }
      this.sendbird.addChannelHandler([types.GLOBAL_HANDLER], channelHandler)
    })
  },
  uploadFile(file) {
    if (!this.channel) return
    const params = new this.sendbird.FileMessageParams()
    params.file = file
    params.fileName = file.name
    params.fileSize = file.size
    params.mimeType = file.type
    params.customType = 'chat_attachment'
    this.channel.sendFileMessage(params, (message, error) => {
      if (!error) store.dispatch('sendbird/addAttachmentToMessageList', message)
    })
  },
  channelExist(channelUrl, callback) {
    if (channelUrl !== undefined && channelUrl !== null) {
      let auditRec = {
        source: 'Portal3',
        userIds: '',
        channel: channelUrl
      }
      this.sendbird.GroupChannel.getChannel(channelUrl)
        .then(channel => {
          auditRec.userIds = channel.creator.userId
          auditRec.details = '(ChannelExist) Group Channel Exists: ' + JSON.stringify(channel)
          store.dispatch('sendbird/audit', auditRec)
          console.log('Group Channel Exists:', channel)
          callback(true)
        })
        .catch(error => {
          // Handle the error and prevent it from being an uncaught rejection
          switch (error.code) {
            case 400404:
              auditRec.details = '(ChannelExist) The channel you are trying to access does not exist.'
              break
            case 400201:
              auditRec.details = '(ChannelExist) Channel not found. Please check the channel URL.'
              break
            case 400300:
              auditRec.details = '(ChannelExist) Session expired. Please log in again.'
              break
            default:
              auditRec.details = '(ChannelExist) An unknown error occurred: ' + error.message
          }
          store.dispatch('sendbird/audit', auditRec)
          callback(false)
        })
    }
  },
  createNewChannel: function (data, callback) {
    var validateUser = function (channel, callback) {
      let userProfile = store.getters['auth/userProfile']
      if (channel.members !== null) {
        let found = false
        for (var i = 0; i < channel.members.length; i++) {
          if (channel.members[i].userId === userProfile.email) {
            found = true
            break
          }
        }
        if (!found) {
          channel.join((joinedChannel, error) => {
            if (error) {
              let auditRec = {
                source: 'Portal3',
                userIds: channel.members.join(', '),
                channel: joinedChannel,
                details: '(createNewChannel) Error (validateUser) ' + error
              }
              console.log('Error (validateUser)', error)
              store.dispatch('sendbird/audit', auditRec)
            }
            callback(joinedChannel)
          })
        } else {
          callback(channel)
        }
      }
    }
    if (data !== undefined && data !== null) {
      if (data.channelUrl !== undefined && data.channelUrl !== null) {
        if (data.channelUrl !== '0' && data.channelUrl !== '1') {
          this.sendbird.GroupChannel.getChannel(data.channelUrl)
            .then(channel => {
              if (channel !== null) {
                this.setChannel(channel)
                validateUser(channel, callback)
              } else {
                let auditRec = {
                  source: 'Portal3',
                  userIds: data.userIds.join(', '),
                  channel: data.channelUrl,
                  details: '(createNewChannel) Missing Channel'
                }
                store.dispatch('sendbird/audit', auditRec)
                callback({ error: true, message: 'Missing Channel' })
              }
            })
            .catch(error => {
              // Handle the error and prevent it from being an uncaught rejection
              if (error.code === 400201) {
                let auditRec = {
                  source: 'Portal3',
                  userIds: data.userIds.join(', '),
                  channel: data.channelUrl,
                  details: `(createNewChannel) Channel not found. Creating channel: ${data.channelUrl}`
                }
                store.dispatch('sendbird/audit', auditRec)
                let languages = 'en'
                if (data.language !== undefined && data.language !== null) {
                  languages += `,${data.language}`
                }
                let params = new this.sendbird.GroupChannelParams()
                params.isDistinct = false
                params.isPublic = true
                params.isDiscoverable = true
                params.channelUrl = data.channelUrl
                params.name = data.name
                params.addUserIds(data.userIds)
                params.customType = globals.channelType()
                params.data = languages
                this.sendbird.GroupChannel.createChannel(params, (channel, error) => {
                  if (error) {
                    let auditRec = {
                      source: 'Portal3',
                      userIds: data.userIds.join(', '),
                      channel: data.channelUrl,
                      details: `(createNewChannel) ${error}`
                    }
                    store.dispatch('sendbird/audit', auditRec)
                    console.log(`DEBUG => sendbird.js -> Error calling GroupChannel.createChannel: ${error}`)
                    return
                  }
                  this.setChannel(channel)
                  auditRec.details = `(createNewChannel) Channel successfully created: ${data.channelUrl}`
                  store.dispatch('sendbird/audit', auditRec)
                  callback(channel)
                })
              } else {
                console.log(`DEBUG => sendbird.js -> Error calling GroupChannel.getChannel ${error}`)
              }
            })
        } else {
          let auditRec = {
            source: 'Portal3',
            userIds: data.userIds.join(', '),
            channel: data.channelUrl,
            details: '(createNewChannel) Invalid channel name (0, 1)'
          }
          store.dispatch('sendbird/audit', auditRec)
          callback({ error: true, message: 'Invalid channel name (0, 1)' })
        }
      } else {
        let auditRec = {
          source: 'Portal3',
          userIds: data.userIds.join(', '),
          channel: '',
          details: '(createNewChannel) Channel name missing'
        }
        store.dispatch('sendbird/audit', auditRec)
        callback({ error: true, message: 'Channel name missing' })
      }
    } else {
      let auditRec = {
        source: 'Portal3',
        userIds: data.userIds.join(', '),
        channel: data.channelUrl,
        details: '(createNewChannel) Channel parameters missing'
      }
      store.dispatch('sendbird/audit', auditRec)
      callback({ error: true, message: 'Channel parameters missing' })
    }
  },
  setChannel: function (channel) {
    this.channel = channel
  },
  getChannelInfo: function (channel, callback) {
    let self = this
    this.memberCount = channel.memberCount > 9 ? types.MAX_COUNT : channel.memberCount.toString()
    this.memberList = []
    let userProfile = store.getters['auth/userProfile']
    let currentUserId = userProfile.email
    channel.markAsRead()
    channel.members.forEach(function (member) {
      if (member.userId !== currentUserId) {
        self.memberList.push(self.xssEscape(member.nickname))
      }
    })
    this.channelSet = {
      channel: channel,
      query: channel.createPreviousMessageListQuery()
    }
    callback(this.channelSet)
  },
  getMessageList: function (callback) {
    if (!this.channelSet.query) {
      this.channelSet.query = this.channelSet.channel.createPreviousMessageListQuery()
    }
    if (this.channelSet.query.hasMore && !this.channelSet.query.isLoading) {
      this.channelSet.query.load(types.GET_MESSAGE_LIMIT, false, function (messageList, error) {
        if (error) {
          console.error(error)
          return
        }
        callback(messageList)
      })
    }
  },
  insertMessageInList: function (target, index, item) {
    return target.splice(index, 0, item)
  },
  sendMessage: function (message, callback) {
    let languages = []
    let language = store.getters['auth/language']
    if (language !== undefined && language !== null) {
      languages.push(language)
    }

    languages.push('en')

    let auditRec = {
      source: 'Portal3',
      userIds: this.channel.inviter.userId,
      channel: this.channel.url
    }

    this.channel.sendUserMessage(message, null, null, languages, (message, error) => {
      if (error) {
        console.error(error)
        auditRec.details = `(sendMessage) Error: ${error}`
        store.dispatch('sendbird/audit', auditRec)
        return
      }
      auditRec.details = `(sendMessage) ${message.message}`
      store.dispatch('sendbird/audit', auditRec)
      callback(message)
    })
  },
  getTotalUnreadCount: function (callback) {
    this.sendbird.getTotalUnreadMessageCount(unreadCount => {
      store.dispatch('serviceRequests/totalUnreadChats', unreadCount)
      if (callback) {
        callback(unreadCount)
      }
    })
  },
  getChannelList(ids, url) {
    let urls = []
    if (this.sendbird === undefined || this.sendbird === null) {
      this.initSendBird()
    }
    if (ids !== undefined && ids !== null) {
      for (let id of ids) {
        urls.push('group_channel_' + id)
      }
    } else if (url !== undefined && url !== null) {
      urls.push(url)
    }
    if (urls.length > 0) {
      if (this.sendbird !== undefined && this.sendbird !== null) {
        if (urls.length > 0 && (this.sendbird.GroupChannel !== undefined && this.sendbird.GroupChannel !== null)) {
          this.channelListQuery = this.sendbird.GroupChannel.createMyGroupChannelListQuery()
          this.channelListQuery.includeEmpty = true
          this.channelListQuery.limit = 50
          this.channelListQuery.channelUrlsFilter = urls
          this.channelListQuery.next(function (channelList, error) {
            if (error) {
              console.error(error)
              return
            }
            store.dispatch('serviceRequests/updateUnreadChats', channelList)
          })
        }
      }
    }
  },
  xssEscape: function (target) {
    if (typeof target === 'string') {
      return target
        .split('&')
        .join('&amp')
        .split('#')
        .join('&#35')
        .split('<')
        .join('&lt')
        .split('>')
        .join('&gt')
        .split('"')
        .join('&quot')
        .split("'")
        .join('&apos')
        .split('+')
        .join('&#43')
        .split('-')
        .join('&#45')
        .split('(')
        .join('&#40')
        .split(')')
        .join('&#41')
        .split('%')
        .join('&#37')
    } else {
      return target
    }
  },
  getMessageTime: function (message) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

    var _getDay = val => {
      let day = parseInt(val)
      if (day === 1) {
        return day + 'st'
      } else if (day === 2) {
        return day + 'en'
      } else if (day === 3) {
        return day + 'rd'
      } else {
        return day + 'th'
      }
    }

    var _checkTime = val => {
      return +val < 10 ? '0' + val : val
    }

    if (message) {
      const LAST_MESSAGE_TODAY = 'today'
      const LAST_MESSAGE_YESTERDAY = 'yesterday'
      var _nowDate = new Date()
      var _date = new Date(message.createdAt)
      var _time = _checkTime(_date.getHours()) + ':' + _checkTime(_date.getMinutes())
      if (_nowDate.getDate() - _date.getDate() === 1) {
        return LAST_MESSAGE_YESTERDAY + ' at ' + _time
      } else if (
        _nowDate.getFullYear() === _date.getFullYear() &&
        _nowDate.getMonth() === _date.getMonth() &&
        _nowDate.getDate() === _date.getDate()
      ) {
        return LAST_MESSAGE_TODAY + ' at ' + _time
      } else {
        return months[_date.getMonth()] + ' ' + _getDay(_date.getDate()) + ' at ' + _time
      }
    }
    return ''
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/chat/sendbird.js